/** The Navigator line advertised in the public header's utility bar. */
export const navigatorLine = {
  display: "+61472668010",
  tel: "tel:+61472668010",
  hours: "Mon-Fri 9am-12pm",
} as const;
